/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Encoding_CompleteInputs */



/**
* | output |
* | --- |
* | "Encoding complete..." |
*
* @param {Ateliere_Connect_Status_Encoding_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_encoding_complete = /** @type {((inputs?: Ateliere_Connect_Status_Encoding_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Encoding_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encodage terminé...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kodierung abgeschlossen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codifica completata...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кодирование завершено...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Codificación completada...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编码完成……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エンコードが完了しました...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एनकोडिंग पूरी हो गई...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Codificação concluída...")
	return /** @type {LocalizedString} */ ("Encoding complete...")
});